import _toConsumableArray from '../@babel/runtime/helpers/esm/toConsumableArray.js';
import _classCallCheck from '../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../@babel/runtime/helpers/esm/createClass.js';

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
  },
  e = function e(t) {
    return function () {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      return {
        _$litDirective$: t,
        values: e
      };
    };
  };
var i = /*#__PURE__*/function () {
  function i(t) {
    _classCallCheck(this, i);
  }
  _createClass(i, [{
    key: "_$AU",
    get: function get() {
      return this._$AM._$AU;
    }
  }, {
    key: "_$AT",
    value: function _$AT(t, e, _i) {
      this._$Ct = t, this._$AM = e, this._$Ci = _i;
    }
  }, {
    key: "_$AS",
    value: function _$AS(t, e) {
      return this.update(t, e);
    }
  }, {
    key: "update",
    value: function update(t, e) {
      return this.render.apply(this, _toConsumableArray(e));
    }
  }]);
  return i;
}();

export { i as Directive, t as PartType, e as directive };
